import TB from '@tiger/bridge';
import { Logger } from '@tiger/logger';
import { useEffect } from 'react';
import UI from 'stores/ui';
import URL from 'utils/URL';

/**
 * 拦截链接跳转，在APP中，如果a标签中带有 data-inapp-blank或data-inapp-system属性，则使用 openInNewPage 或 openUrlBySystemBrowser 方法打开链接
 */

const useLinkInterceptor = () => {
    useEffect(() => {
        const handleClick = event => {
            if (UI.isTiger && window.TigerBridge) {
                const target = event.target.closest('a');

                if (
                    target &&
                    target.href &&
                    ((target.hasAttribute('data-inapp-blank') && 'openInNewPage' in window.TigerBridge) ||
                        (target.hasAttribute('data-inapp-system') && 'openUrlBySystemBrowser' in window.TigerBridge))
                ) {
                    event.preventDefault();

                    const url = target.href.startsWith('http')
                        ? target.href
                        : URL.merge(target.href, { host: window.location.host, protocol: window.location.protocol });

                    Logger.log(url, 'hooks/useLinkInterceptor');

                    if (target.hasAttribute('data-inapp-system')) {
                        TB.openUrlBySystemBrowser(url);
                    } else {
                        TB.openInNewPage(url);
                    }
                }
            }
        };

        document.addEventListener('click', handleClick);

        return () => document.removeEventListener('click', handleClick);
    }, []);
};

export default useLinkInterceptor;
